import { Media } from "chq";

const validImageUrl = async (media: Media): Promise<string> => (
  new Promise(resolve => {
    const image = new Image();
    image.onload = () => resolve(media.shareableUrl);
    image.onerror = () => resolve(media.url);
    image.src = media.shareableUrl;
  })
);

export default validImageUrl;
